import { useRef, useEffect } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import IMask from 'imask';

type MaskedTextFieldProps = TextFieldProps & {
    mask?: string;
    inputRef?: any;
}

const MaskedTextField = ({ mask, inputRef, ...props }: MaskedTextFieldProps) => {
    const defaultInputRef = useRef(null);
    // Use a ref passada externamente se existir, caso contrário, use a ref padrão
    const resolvedInputRef = inputRef || defaultInputRef;

    useEffect(() => {
        let maskInstance:any;

        // Garante que o input DOM exista antes de tentar mascarar
        if (resolvedInputRef.current) {
            // O TextField do MUI expõe o input DOM real através de resolvedInputRef.current
            maskInstance = IMask(resolvedInputRef.current, {
                mask: mask,
                // Adicione outras opções do IMask aqui, se necessário (ex: lazy, definitions)
            });

            // Limpeza: remove a instância do IMask quando o componente é desmontado
            return () => {
                maskInstance.destroy();
            };
        }
    }, [mask, resolvedInputRef]); // Re-executa se a máscara ou a ref do input mudar

    return (
        <TextField
            {...props}
            inputRef={resolvedInputRef} // Passa a ref para o TextField para acessar o input DOM
            InputLabelProps={{
                shrink: true, // Garante que o label sempre "encolha" para máscaras
            }
            }
        />
    );
};

export default MaskedTextField;